import React from 'react';
import { selectCircleIcon } from '@/components/my-network/helpers';
import style from './ModalStyles.module.css';
import { formattedCircle } from './helpers';

function CardHeader({ data, startCard }) {
    return (
        <div className={`w-full bg-cleanSlate rounded-t-lg flex flex-col-reverse md:flex-row items-start justify-between py-12 px-6 ${startCard ? style.startingImage : style.mountainBackground}`}>
            {!startCard && (
                <div className="w-full mx-auto flex items-center justify-center">
                    <div className="flex items-center justify-center">
                        {data.contacts.map((contact, index) => {
                            const formatedCircle = formattedCircle(contact.effectiveCircle);

                            return (
                                <div key={`contact-${contact.id}`} className={`flex ${contact.displayNameCol ? 'flex-col' : ''} justify-center items-center ${data.contacts.length < 2 || contact.displayNameCol ? '' : `flex-col ${index === 0 ? ' mr-10' : ''} `}`}>
                                    <div className="w-[160px] h-[160px]">
                                        {contact.avatar}
                                    </div>
                                    {data.contacts.length < 2 ? (
                                        <div className={`flex flex-col ${contact.displayNameCol ? 'items-center justify-center ml-0' : 'ml-4'} `}>
                                            <p className="text-cirrusWhite text-[24px] font-bold mb-[-5px]">{contact.givenName}</p>
                                            <p className="text-cirrusWhite text-[14px] mb-2">{contact.email}</p>
                                            <div className="flex items-center">
                                                <div className="pr-[8px]">
                                                    {selectCircleIcon(formatedCircle)}
                                                </div>
                                                {(formatedCircle) && <p className="text-cirrusWhite text-[12px] font-bold">{`${formatedCircle} contact`}</p>}
                                            </div>
                                        </div>
                                    )
                                        : (
                                            <div className="items-center mt-2">
                                                <p className="text-cirrusWhite text-[24px] font-bold">{contact.givenName}</p>
                                            </div>
                                        )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

export default CardHeader;
